import React, { useState } from 'react';

import { useRouter } from 'next/router';

import { Button, ButtonGroup, Menu, MenuItem, Avatar, Typography } from '@mui/material';

import { AuthContext } from '@klokhuis/core/Auth/AuthContext';
import { useIntl } from '@klokhuis/core/Intl';
import { Locale } from '@klokhuis/core/Intl/types';
import { ROUTES } from '@klokhuis/core/Routing';
import { NavLink } from '@klokhuis/core/Routing/NavLink';

import styles from './HeaderDesktop.module.css';
import { LogoLink } from './LogoLink';

export const HeaderDesktop = () => {
  const router = useRouter();
  const { T, locale } = useIntl();
  const { isAuthenticated, userProfile, signout } = AuthContext.useContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    handleMenuClose();
    router.push(ROUTES.Profile.url({}));
  };

  const handleLogoutClick = () => {
    handleMenuClose();
    signout();
  };

  const isHomePage = router.asPath === ROUTES.Home.url({});

  return (
    <div className={styles.wrapper}>
      <nav className={styles.root}>
        <LogoLink />

        <div className={styles.centralSection}>
          <Button
            variant="contained"
            color="primary"
            component={NavLink.Anchor}
            href={
              isAuthenticated
                ? ROUTES.CreateProperty.url({})
                : ROUTES.SignupSignin.url({
                    returnUrl: ROUTES.CreateProperty.url({}),
                  })
            }
          >
            <Typography variant="body2">
              {T('LBL_HEADER_CREATE_ADVERT')}
            </Typography>
          </Button>
          {/* <ButtonGroup size="small" className={styles.langSwitcher}>
            <Button
              variant={locale === Locale.en ? 'contained' : 'outlined'}
              onClick={() => router.push(router.asPath, router.asPath, { locale: Locale.en })}
            >
              {T('header.lang_switch.en')}
            </Button>
            <Button
              variant={locale === Locale.ta ? 'contained' : 'outlined'}
              onClick={() => router.push(router.asPath, router.asPath, { locale: Locale.ta })}
            >
              {T('header.lang_switch.ta')}
            </Button>
          </ButtonGroup> */}
        </div>
        {isAuthenticated ? (
          <>
            <div
              id="profile-menu-button"
              aria-label="account menu"
              aria-controls="profile-menu"
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              className={styles.userSection}
            >
              <Typography variant="headerNavButton">
                {userProfile?.fullName || ''}
              </Typography>
              <Avatar
                alt={userProfile?.fullName || ''}
                src={userProfile?.profileImage || ''}
                className={styles.avatar}
              />
            </div>
            <Menu
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              id="profile-menu"
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={isMenuOpen}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleProfileClick}>{T('header.menu.profile')}</MenuItem>
              <MenuItem onClick={() => router.push(ROUTES.Inbox.url({}))}>
                {T('header.menu.messages')}
              </MenuItem>
              <MenuItem
                onClick={() => router.push(ROUTES.ManageListing.url({}))}
              >
                {T('header.menu.manage_listings')}
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleMenuClose();
                  router.push(ROUTES.Syndication.url({}));
                }}
              >
                {T('header.menu.syndication')}
              </MenuItem>
              <MenuItem onClick={handleLogoutClick}>{T('header.menu.logout')}</MenuItem>
            </Menu>
          </>
        ) : (
          <NavLink.Native
            href={ROUTES.SignupSignin.url({})}
            className={styles.navLink}
            variant="linkMedium"
            underline="none"
          >
            {T('LBL_LOGIN')}
          </NavLink.Native>
        )}
      </nav>
    </div>
  );
};
